import React, { useEffect, useState, Fragment, } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import { Card } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import DehazeIcon from '@material-ui/icons/Dehaze';
import { IconButton } from '@material-ui/core';
import MaterialTable from "material-table";

export const RoleListing = ({ roleFilteringData, handleClick, handleChange, editEnabled }) => {

    const [roleFiltering, setRoleFiltering] = useState([]);
    const contentRowNames = ["name", "isActive"]

    useEffect(() => {
        trackPromise(
            setRoleFilteringData()
        )
    }, [roleFilteringData]);

    async function setRoleFilteringData() {
        destroyDataTable();
        await setRoleFiltering(roleFilteringData);
        createDataTable();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    });



    return (
        <Fragment>
            <LoadingSpinerComponent />
            <Card style={{ justifycontent: 'center' }}>

                <MaterialTable
                    title="Multiple Actions Preview"
                    columns={[
                        { title: 'Role Name', field: 'name', headerStyle: { fontWeight: "bold" } },
                        {
                            title: 'Status', field: 'isActive',
                            render: rowData => rowData.isActive == true ? "Active" : "Inactive", headerStyle: { fontWeight: "bold" }
                        },
                        {
                            title: 'Action', field: 'select', headerStyle: { fontWeight: "bold", textAlign: "center" },
                            render: (data) => (
                                <center>
                                    <IconButton aria-label="create" onClick={() => handleClick(data)}>
                                        <CreateIcon />
                                    </IconButton>
                                    <IconButton aria-label="dehaze" onClick={() => handleChange(data)}>
                                        <DehazeIcon />
                                    </IconButton>
                                </center>

                            )
                        }
                    ]}
                    data={roleFiltering}
                    options={{
                        exportButton: false,
                        showTitle: false,
                        headerStyle: { textAlign: "left", height: '1%' },
                        cellStyle: { textAlign: "left" },
                        columnResizable: false,
                        actionsColumnIndex: -1
                    }}
                />
            </Card>
        </Fragment>
    );
}


